module.exports = __webpack_public_path__ + "10591474ee3e18d1e6aa6a24ded22f42.woff2";